import {
  BottomSheetDialog,
  Button,
  Div,
  ImageView,
  Label,
  LoadingIndicator,
  Toast,
} from 'components';
import {Ecolors, Icons, stringApp, urlApp} from 'constant';
import React, {useRef, useState} from 'react';
import {Platform} from 'react-native';
// import ReactNativeBlobUtil from 'react-native-blob-util';
// import RNFS from 'react-native-fs';
// import {PERMISSIONS} from 'react-native-permissions';
import {useSafeAreaInsets} from 'react-native-safe-area-context';
import {useAppSelector} from 'store/hooks';
import {
  convertDataDownloadFile,
  downloadFileWebview,
  getUuid,
  requestPermisson,
} from 'utils';
import {getStoreToken} from 'utils/storage';

function ButtonDownloadAgentcyFile() {
  const [loading, setLoading] = useState<boolean>(false);
  const currentUser = useAppSelector(state => state.authen.currentUser);
  const bottomSheetUpload = useRef<any>(null);
  const insets = useSafeAreaInsets();

  const {agentcyInfo} = currentUser;

  const downloadConfirm = async (p?: {agentTypeCode?: 1 | 2}) => {
    if (loading) return;
    setLoading(true);

    try {
      const token = await getStoreToken();
      const url = `user-agentcy/file/contract?agentTypeCode=${
        p?.agentTypeCode || agentcyInfo?.agentTypeCode
      }`;
      const bburl = `${urlApp.APIURL}api/${url}`;

      const res = await fetch(bburl, {
        method: 'GET',
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
          'request-id': getUuid(),
          Origin: urlApp.DomainName,
        },
      });

      if (!res.ok) throw new Error('Download failed');

      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = `${getUuid()}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();

      URL.revokeObjectURL(blobUrl);

      Toast.show({
        content: 'alert.taithanhcong',
        multilanguage: true,
      });
    } catch (e) {
      Toast.show({
        content: 'alert.daxayraloi',
        multilanguage: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <BottomSheetDialog
        style={{
          flexDirection: 'column',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
        ref={bottomSheetUpload}>
        <Button
          onPress={() => {
            bottomSheetUpload.current.hide();
            downloadConfirm({
              agentTypeCode: 2, //canhan
            });
          }}
          width={345}
          height={48}
          borderRadius={8}
          backgroundColor={Ecolors.whiteColor}
          alignItems="center"
          justifyContent="center"
          marginBottom={14}>
          <Label color={Ecolors.linkColor}>{`agentcy.canhan`}</Label>
        </Button>
        <Button
          onPress={() => {
            bottomSheetUpload.current.hide();
            downloadConfirm({
              agentTypeCode: 1, //dailybaohiem
            });
          }}
          width={345}
          height={48}
          borderRadius={8}
          backgroundColor={Ecolors.whiteColor}
          alignItems="center"
          justifyContent="center"
          marginBottom={insets.bottom + 14}>
          <Label color={Ecolors.linkColor}>{`agentcy.dailybaohiem`}</Label>
        </Button>
      </BottomSheetDialog>
      {agentcyInfo?.isEsign && (
        <Div paddingHorizontal={20} paddingTop={20}>
          <Label size={14}>{`agentcy.content`}</Label>
        </Div>
      )}
      <Div
        width={'100%'}
        alignItems={'center'}
        justifyContent={'center'}
        paddingBottom={20}>
        <Button
          width={340}
          height={48}
          flexDirection={'row'}
          marginTop={18}
          onPress={() => {
            if (!agentcyInfo?.agentTypeCode) {
              bottomSheetUpload.current.show();
              return;
            }
            downloadConfirm({
              agentTypeCode: agentcyInfo?.agentTypeCode,
            });
            return;
          }}
          borderRadius={5}
          borderWidth={0.8}
          borderColor={Ecolors.mainColor}
          backgroundColor={Ecolors.spaceColor}
          alignItems={'center'}
          justifyContent={'center'}>
          {loading ? (
            <LoadingIndicator color={Ecolors.mainColor} />
          ) : (
            <>
              <ImageView
                source={Icons.download}
                widthHeight={18}
                resizeMode={'contain'}
                marginRight={10}
              />
              <Label fontWeight={'700'} size={15}>
                {`agentcy.taihopdongcongtacvien`}
              </Label>
            </>
          )}
        </Button>
      </Div>
    </>
  );
}

export default React.memo(ButtonDownloadAgentcyFile);
